import { Component, OnInit, Inject, Input } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectionService } from 'src/app/modules/organization/connection.service';
import { ConnectionDialogComponent } from '../dialog/connection-dialog/connection.dialog';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CommonModule, Location } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';

@Component({
    selector: 'connection-info-header',
    templateUrl: './connection-info-header.component.html',
    styleUrls: ['./connection-info-header.component.css'],
    imports: [MatCardModule, MatIconModule, MatButtonModule, MatDialogModule, FlexLayoutModule, CommonModule, MatTooltip]
})

export class ConnectionInfoHeaderComponent implements OnInit {
  constructor(
    private _snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private connectionService: ConnectionService,
    private dialog: MatDialog,
    private location: Location
  ) {}

  @Input() box: any
  @Input() objectId: any
  @Input() connection: any
  @Input() starch: any

  showObject: boolean = false;

  ngOnInit(): void {
    if(this.objectId) this.showObject = true
  }

  editConnectionData(connection?: any) {
    // this.connection = this.navigation?.extras?.state?.connection;
    let preAuthenticatedToken = this.connectionService.preAuthenticatedToken;
    console.log('connection-explorer component CONNECTION', connection);
    this.router.navigate(['connection/newconnection'], {
      queryParams: {
        workspaceid: connection.workSpace_id,
        authorization: encodeURIComponent(preAuthenticatedToken),
        isEdit: true,
      },
      state: { connection: connection, con_explorer: true },
    });
  }

  deleteConnectionData(connection?: any) {
    // this.connection = this.navigation?.extras?.state?.connection;
    let preAuthenticatedToken = this.connectionService.preAuthenticatedToken;
    let response: any;
    let dialogRef = this.dialog.open(ConnectionDialogComponent, {
      minWidth: '60%',
      data: { name: connection.name },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        try{
          response = await this.connectionService.deleteConnection(connection._id, preAuthenticatedToken)
          console.log(response);
          let snackBarObj = {
            snackBarMessage: 'Connection Deleted Successfully',
            snackBarIcon: 'check_circle',
            snackBarDuration: 4000,
            snackBarError: false,
          };
          this.openSnackBar(snackBarObj);
          this.location.back();
        }catch(e){
          console.log(e);
          let snackBarObj = {
            snackBarMessage: 'Error while Deleting Connection',
            snackBarIcon: 'error',
            snackBarDuration: 6000,
            snackBarError: true,
          };
          this.openSnackBar(snackBarObj);
          throw e
        }
      }
    });
  }

  openSnackBar(snackBarObj: any) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: {
        message: snackBarObj.snackBarMessage,
        iconname: snackBarObj.snackBarIcon,
      },
      duration: snackBarObj.snackBarDuration,
      horizontalPosition: 'end',
    });
  }

}
